import { request } from 'utils/request'

import accounts from './accounts'
import ade from './ade'
import awarenessCenter from './awarenessCenter'
import companies from './companies'
import dashboard from './dashboard'
import groupSettings from './groupSettings'
import investigation from './investigation'
import login from './login'
import mailboxes from './mailboxes'
import msp from './msp'
import reports from './reports'
import resolutionCenter from './resolutionCenter'
import settings from './settings'
import threatLog from './threatLog'
import visualDetection from './visualDetection'
import wizardCampaign from './wizardCampaign'

export default {
  login: login(),
  accounts: accounts(request),
  companies: companies(request),
  dashboard: dashboard(request),
  settings: settings(request),
  msp: msp(),
  reports: reports(),
  mailboxes: mailboxes(),
  visualDetection: visualDetection(),
  awarenessCenter: awarenessCenter(),
  resolutionCenter: resolutionCenter(),
  wizardCampaign: wizardCampaign(),
  groupSettings: groupSettings(),
  threatLog: threatLog(),
  investigation: investigation(),
  ade: ade(),
}
